var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.8V11.2C17 11.6774 16.8055 12.1352 16.4593 12.4728C16.1131 12.8104 15.6435 13 15.1538 13H2.84615C2.35652 13 1.88695 12.8104 1.54073 12.4728C1.1945 12.1352 1 11.6774 1 11.2V2.8M17 2.8C17 2.32261 16.8055 1.86477 16.4593 1.52721C16.1131 1.18964 15.6435 1 15.1538 1H2.84615C2.35652 1 1.88695 1.18964 1.54073 1.52721C1.1945 1.86477 1 2.32261 1 2.8M17 2.8V2.9944C17 3.30172 16.9194 3.60392 16.7657 3.87224C16.612 4.14055 16.3904 4.36603 16.1221 4.5272L9.96821 8.2192C9.67709 8.39403 9.3419 8.4866 9 8.4866C8.6581 8.4866 8.32291 8.39403 8.03179 8.2192L1.87795 4.528C1.60958 4.36683 1.388 4.14135 1.23431 3.87304C1.08063 3.60472 0.999965 3.30252 1 2.9952V2.8",
    stroke: "#00848D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.01410c1e57e2debcb3170efcf98d4609.svg";
export { ForwardRef as ReactComponent };